<template>
  <div>
    <b-row>
      <b-col md="4" class="mb-3">
        <label class="lbl">CEP <span class="req">*</span></label>
        <b-form-input
          v-model="local.cep"
          class="inp"
          placeholder="00000-000"
          :disabled="locked"
          :state="cepValido(local.cep)"
          @input="onCep"
        />
      </b-col>
      <b-col md="8" class="mb-3">
        <label class="lbl">Logradouro <span class="req">*</span></label>
        <b-form-input
          v-model="local.logradouro"
          class="inp"
          :disabled="locked"
          :state="preenchido(local.logradouro)"
        />
      </b-col>
      <b-col md="3" class="mb-3">
        <label class="lbl">Número <span class="req">*</span></label>
        <b-form-input
          v-model="local.numero"
          class="inp"
          :disabled="locked"
          :state="preenchido(local.numero)"
        />
      </b-col>
      <b-col md="5" class="mb-3">
        <label class="lbl">Complemento</label>
        <b-form-input v-model="local.complemento" class="inp" :disabled="locked" />
      </b-col>
      <b-col md="4" class="mb-3">
        <label class="lbl">Bairro <span class="req">*</span></label>
        <b-form-input
          v-model="local.bairro"
          class="inp"
          :disabled="locked"
          :state="preenchido(local.bairro)"
        />
      </b-col>
      <b-col md="8" class="mb-3">
        <label class="lbl">Cidade <span class="req">*</span></label>
        <b-form-input
          v-model="local.cidade"
          class="inp"
          :disabled="locked"
          :state="preenchido(local.cidade)"
        />
      </b-col>
      <b-col md="4" class="mb-3">
        <label class="lbl">UF <span class="req">*</span></label>
        <b-form-input
          v-model="local.uf"
          class="inp"
          :disabled="locked"
          maxlength="2"
          style="text-transform:uppercase"
          :state="ufValida(local.uf)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "EnderecoForm",
  props: {
    titulo: { type: String, default: "" },
    model: { type: Object, default: () => ({}) },
    locked: { type: Boolean, default: false },
    requiredAll: { type: Boolean, default: false },
  },
  data() {
    return {
      local: Object.assign(
        { cep: "", logradouro: "", numero: "", complemento: "", bairro: "", cidade: "", uf: "" },
        this.model
      ),
    };
  },
  watch: {
    model: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.local)) {
          this.local = Object.assign({}, this.local, val);
        }
      },
      deep: true,
    },
    local: {
      handler(val) {
        this.$emit("update:model", { ...val });
      },
      deep: true,
    },
  },
  methods: {
    onCep(value) {
      const digits = value.replace(/\D/g, "");
      if (digits.length === 8) this.$emit("cep", digits);
    },
    preenchido(v) {
      return !!(v && String(v).trim().length > 0);
    },
    cepValido(v) {
      return !!(v && String(v).replace(/\D/g, "").length === 8);
    },
    ufValida(v) {
      return !!(v && String(v).trim().length === 2);
    },
  },
};
</script>

<style scoped>
.lbl {
  display: block;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #64748b;
  margin-bottom: 6px;
}
.req {
  color: #D42859;
  font-weight: 700;
}
.inp {
  height: 40px !important;
  padding: 0 14px !important;
  border-radius: 10px !important;
  border: 1.5px solid #e2e8f0 !important;
  font-size: 0.875rem !important;
  background: #ffffff !important;
  color: #0f172a !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04) !important;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.inp:hover:not(:focus) {
  border-color: #cbd5e1 !important;
}
.inp:focus {
  border-color: #05428E !important;
  box-shadow: 0 0 0 4px rgba(5, 66, 142, 0.12) !important;
  outline: none !important;
}
.inp.is-valid {
  border-color: #00BD80 !important;
  background: rgba(0, 189, 128, 0.03) !important;
  background-image: none !important;
  padding-right: 14px !important;
}
.inp.is-valid:focus {
  box-shadow: 0 0 0 4px rgba(0, 189, 128, 0.12) !important;
}
.inp.is-invalid {
  border-color: #D42859 !important;
  background: rgba(212, 40, 89, 0.03) !important;
  background-image: none !important;
  padding-right: 14px !important;
}
.inp.is-invalid:focus {
  box-shadow: 0 0 0 4px rgba(212, 40, 89, 0.12) !important;
}
</style>
